import { BookingItemInterface } from "./BookingItemInterface";
import { TS_AddonTrain } from "../TravelSeller/Models/TS_AddonTrain";

export class AddonTrain extends TS_AddonTrain implements BookingItemInterface {}
